import { CALENDAR_VIEWS } from './calendarViewPreference';

export const START_PAGES = [
  { id: 'calendar', label: 'Calendar', path: '/biz/calendar?v=booking', workspace: true },
  { id: 'bookingTypes', label: 'Booking Types', path: '/biz/bookingtypes?v=booking', workspace: true },
  { id: 'schedule', label: 'My Schedule', path: '/myschedule' },
  { id: 'workspaces', label: 'Workspaces', path: '/workspaces' },
];
const key = userId => `timely-start-page:${userId}`;
export function readStartPage(userId) {
  if (!userId) return '';
  try {
    const value = localStorage.getItem(key(userId));
    return START_PAGES.some(page => page.id === value) ? value : '';
  } catch { return ''; }
}
export function saveStartPage(userId, value) {
  if (!userId || !START_PAGES.some(page => page.id === value)) return false;
  try { localStorage.setItem(key(userId), value); return true; } catch { return false; }
}
export function preferredStartPath(user) {
  const page = START_PAGES.find(item => item.id === readStartPage(user?.userId));
  // The initial login token can lack a default workspace. Let the destination
  // load memberships and enforce access instead of discarding the preference.
  return page?.path || null;
}

export function clearStorageForLogout() {
  const preferences = Object.keys(localStorage)
    .map(name => [name, localStorage.getItem(name)])
    .filter(([name, value]) =>
      (name.startsWith('timely-start-page:') && START_PAGES.some(page => page.id === value)) ||
      (name.startsWith('timely-calendar-view:') && CALENDAR_VIEWS.includes(value)) ||
      (name.startsWith('timely-sidebar:') && ['expanded', 'collapsed'].includes(value)));
  localStorage.clear();
  preferences.forEach(([name, value]) => localStorage.setItem(name, value));
}
